// Admin / internal-tool UI copy.
//
// These strings are surfaced only in the platform-admin surface
// (apps/app/src/routes/admin/*) plus the producer-side rate-import form
// (RateImportForm). They are seen by Lerfilm operators / OHEAR.AI staff,
// not by talent — but we still localize so the same OPs team can run the
// tool in any of our three supported locales.
//
// Tone: terse, operational. Spanish uses "usted"; Chinese uses Simplified.
/** Form labels & filters in the admin surface. */
export const FILTERS = {
    filter_by_org: {
        en: 'Filter by org',
        es: 'Filtrar por organización',
        zh: '按组织筛选',
    },
};
/** Empty-state messages shown when admin lists return zero rows. */
export const EMPTY = {
    archival_nothing: {
        title: {
            en: 'Nothing archived',
            es: 'Sin archivos',
            zh: '暂无归档',
        },
        body: {
            en: 'No projects are currently in cold tier.',
            es: 'Ningún proyecto está actualmente en almacenamiento en frío.',
            zh: '目前没有项目处于冷存储层。',
        },
    },
};
/** Section / dialog headings. */
export const HEADINGS = {
    import_rates_csv: {
        en: 'Import rates from CSV',
        es: 'Importar tarifas desde CSV',
        zh: '从 CSV 导入费率',
    },
};
